/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Effects_DescInputs */

const en_fc_home_features_effects_desc = /** @type {(inputs: Fc_Home_Features_Effects_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over 90 video effects, about 30 transitions and keyframes with value and velocity graphs, composited on the GPU.`)
};

/**
* | output |
* | --- |
* | "Over 90 video effects, about 30 transitions and keyframes with value and velocity graphs, composited on the GPU." |
*
* @param {Fc_Home_Features_Effects_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_effects_desc = /** @type {((inputs?: Fc_Home_Features_Effects_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Effects_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_effects_desc(inputs)
});
export { fc_home_features_effects_desc as "fc.home.features.effects.desc" }